import { AccountFragment } from 'src/graphql/generated/graphql'

const hasExpenseBucket = (account: AccountFragment): boolean =>
  !!account.expenseReload

export default hasExpenseBucket
